<template>
    <div>
        <mml-base-header-sec></mml-base-header-sec>

        <div class="container-fluid base-container">
            <div class="base-box base-box__table-sec">
                <table class="table  table-striped table-sm table-slglrs" width="100%">
                    <thead>
                        <tr>
                            <th scope="col" style="padding-left: 50px;">Врста</th>
                            <th scope="col">Назив доносиоца / Име аутора</th>
                            <th scope="col">Ближе одређење материје / назив</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in result" v-bind:key="index">
                            <td>{{ item.rootType }}</td>
                            <td>{{ item.authority }}</td>
                            <td class="td-link">

                                <!--                            <a :href="baseUrl +'mml/viewAct/naziv-akta/' + item.id" target="_blank">{{item.actCloserDesignation}}</a>-->
                                <!--http://10.10.30.99:8080/SlGlasnikPortal/mml/viewAct/11194-->
                                <!--                            :to="'/mml/viewAct/naziv-akta/'+item.id"-->
                                <router-link v-if="canOpen === 'can_open'" target="_blank"
                                    :to="{ path: '/mml/viewAct/' + item.id }">{{
                                        item.actCloserDesignation
                                    }}</router-link>
                                <a v-if="canOpen === 'not_logged_in'" v-b-modal.login-modal href="#" @click.stop.prevent>
                                    {{ item.actCloserDesignation }}
                                </a>
                                <a v-if="canOpen === 'role_not_allowed'" href="#" @click.stop.prevent="role_not_allowed()">
                                    {{ item.actCloserDesignation }}
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import MmlBaseHeaderSec from '@/base_pages/mml/MmlBaseHeaderSec.vue';
import { mapState } from 'vuex';


export default {
    name: "MmlLatestPage",
    data() {
        return {
            isActOpen: false,
            actHTML: '',
            result: [],
            resultSize: null,
            baseApiUrl: window.env.VUE_APP_API_MML_DEV,
             
            meta: {
                title: 'Правно-информациони систем РС',
                description: 'Правно-информациони систем je збирка података у електронском облику која садржи: електронски облик Службеног гласника, архиву службених гласила, базу која садржи регистар и текстове важећих прописа и других аката Републике Србије објављених у Службеном гласнику, базу која садржи судску праксу, друге податке о правном систему Републике Србије и везу с правним актима Европске уније.',
                keywords: 'zakoni, akti, zakonski, propisi, sudska praksa, registar, odluka, sudovi, ugovori, pravno informacioni sistem, prins, pis,sluzbeni glasnik',
            },
        }
    },
    metaInfo() {
        return {
            title: this.meta.title,
            meta: [
                { name: 'title', content: this.meta.title },
                { name: 'description', content: this.meta.description },
                { name: 'keywords', content: this.meta.keywords },
            ],
        }
    },
    components: {
        MmlBaseHeaderSec,
    },
    computed: {
        ...mapState(['userInfoState']),

        canOpen() {
            if (this.userInfoState) {
                if (this.userInfoState.roles.includes('LSD')) {
                    return 'can_open';
                } else {
                    return 'role_not_allowed';
                }
            } else {
                return 'not_logged_in';
            }
        },
    },
    methods: {
        role_not_allowed() {
            alert('Немате приступ овој бази');
        },
        fetchData() {
            axios.get(this.baseApiUrl + 'prins/latestActs')
                .then(response => {
                    this.result = response.data;
                });
        }
    },
    created() {
        this.fetchData();
    },
    beforeCreate: function () {
        document.body.className = 'color_mml';
    }
}
</script>

<style scoped></style>
